import { FaIcon } from '@ifixit/ui/components/icon';
import { cn } from '@ifixit/ui/lib/utils';

/** Icon tiles in the footer cards' shape; the tones speak the editors'
 *  status colors — emerald for done, red for a load failure, brand for a
 *  neutral empty state. */
const MESSAGE_CARD_TONES = {
   done: 'border-emerald-200 bg-emerald-100 text-emerald-600',
   failure: 'border-red-200 bg-red-100 text-red-600',
   info: 'border-brand-200 bg-brand-100 text-brand-500',
} as const;

export type MessageCardTone = keyof typeof MESSAGE_CARD_TONES;

/**
 * A centered empty/error state inside a dashboard card: icon tile, one
 * bold line, one muted line. Shared by the /Translate queues and the
 * /Leaderboard ranking.
 */
export function MessageCard({
   icon,
   tone,
   title,
   text,
}: {
   icon: string;
   tone: MessageCardTone;
   title: string;
   text: string;
}) {
   return (
      <div className="flex flex-col items-center gap-3 px-4 py-12 text-center">
         <span
            className={cn(
               'flex size-9 items-center justify-center rounded-md border',
               MESSAGE_CARD_TONES[tone]
            )}
         >
            <FaIcon name={icon} className="size-4 fill-current" />
         </span>
         <div className="max-w-md">
            <p className="text-sm font-medium text-gray-900">{title}</p>
            <p className="mt-1 text-sm text-gray-500">{text}</p>
         </div>
      </div>
   );
}
